import { render, staticRenderFns } from "./SendMessageHistory.vue?vue&type=template&id=683af6ca&scoped=true&lang=pug"
import script from "./SendMessageHistory.vue?vue&type=script&lang=ts"
export * from "./SendMessageHistory.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageHistory.vue?vue&type=style&index=0&id=683af6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683af6ca",
  null
  
)

export default component.exports